let scrollBodyCoordinate = 0;

/*
 * We need to store the scroll position to restore it when the user clicks on the button
 * and lock the scroll on the body once the flyout is open
 * This function is called after the opening animation.
 *
 * For reasons unknown to me document.body.clientHeight is giving the full document height
 * including the scroll on page load. That is reason for the window.innerHeight
 */
export const lockWindowScroll = () => {
  if (document.body.scrollHeight > window.innerHeight) {
    document.body.style.overflowY = 'scroll';
  }

  scrollBodyCoordinate = window.scrollY;

  document.body.style.position = 'fixed';
  document.body.style.width = '100%';

  return scrollBodyCoordinate;
};

/*
 * We restore the scroll position and remove the scroll on on the body
 * This function is called after the end of the closing animation
 */

export const unlockWindowScroll = () => {
  if (document.body.scrollHeight > window.innerHeight) {
    document.body.style.removeProperty('overflow-y');
  }

  document.body.style.position = '';
  document.body.style.width = '';

  window.scrollTo(0, scrollBodyCoordinate || 0);
};
